import { render, staticRenderFns } from "./LanguageSwitchModal.vue?vue&type=template&id=0b8ca62d&scoped=true"
import script from "./LanguageSwitchModal.vue?vue&type=script&lang=js"
export * from "./LanguageSwitchModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitchModal.vue?vue&type=style&index=0&id=0b8ca62d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ca62d",
  null
  
)

export default component.exports